export default {
    getCategoriaDefaultProdutoById: state => (produtoId) => {
        let result = state.produtos.find(x => x.id === produtoId)?.categoriaDefault;
        return result ? result : "";
    }
}